/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  Call,
  CallsControllerFindAllV1200AllOf,
  CallsControllerFindAllV1Params,
  CallsControllerFindAllV1PathParameters,
  CallsControllerFindOneV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class CallsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get Call Quality detail for a single call
   */

  findOne<TData = Call>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: CallsControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/calls/${id}`);
  }
  /**
   * @summary Get Calls list
   */

  findAll<TData = CallsControllerFindAllV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: CallsControllerFindAllV1PathParameters,
    params?: CallsControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/calls`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
